import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { CookieStorageService } from 'src/app/shared/services/cookie-storage.service';

@Injectable({ providedIn: 'root' })
export class OktaSessionGuard  {

  private currentUser: string = 'currentUser'

  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
                       private cookieStorageSerivce: CookieStorageService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const sessionExists = await this.oktaAuth.session.exists();
    var currentMFEUser = (await this.oktaAuth.getUser()).sub;
    var currentLegacyUser = this.cookieStorageSerivce.get(this.currentUser);

    if (currentLegacyUser &&  currentMFEUser !== currentLegacyUser) {
      this.cookieStorageSerivce.delete(this.currentUser);
      this.oktaAuth.clearStorage();
      localStorage.setItem('currentRedirection', state.url);
      return false;
    }
  
    if (!sessionExists) {
      this.cookieStorageSerivce.delete(this.currentUser);
      this.oktaAuth.clearStorage();
      return false;
    }
    return true;
  }
}
